import { gql } from '@apollo/client';

export const getUserFilters = gql`
  query GetUserLOVs {
    core {
      getRoles
      getUserAccesses {
        id
        code
        title
      }
    }
    UserStatus: __type(name: "UserStatus") {
      name
      enumValues {
        name
      }
    }
    UserType: __type(name: "UserType") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getUsersList = gql`
  query searchUsers(
    $pagination: PaginationInput!
    $OrderBy: OrderByInput
    $selectedTypes: [String!]
    $businessUserStatus: [String!]
    $selectedAccesses: [String!]
    $selectedRoles: [String!]
    $createdDateFrom: DateTime
    $createdDateTo: DateTime
    $keywordSearch: String
  ) {
    core {
      searchUsers(
        keyword: $keywordSearch
        pagination: $pagination
        orderBy: $OrderBy
        selectedTypes: $selectedTypes
        selectedAccesses: $selectedAccesses
        selectedStatuses: $businessUserStatus
        selectedRoles: $selectedRoles
        createdOnStart: $createdDateFrom
        createdOnEnd: $createdDateTo
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          id
          code
          userName
          email
          access
          phoneNumber
          status
          type
          createdOn
          accessFailedCount
          createdBy
          concurrencyStamp
          emailConfirmed
          firstName
          lastName
          middleName
          modifiedOn
          userRoles {
            role {
              name
            }
          }
        }
      }
    }
  }
`;

export const getUserDetailsById = gql`
  query getUserDetailsById($id: ID!) {
    core {
      getUserDetails(userId: $id) {
        user {
          personId
          createdBy
          modifiedBy
          userRoles {
            role {
              id
              name
            }
          }
          id
          type
          userName
          normalizedUserName
          email
          normalizedEmail
          emailConfirmed
          firstName
          middleName
          lastName
          phoneNumber
          status
          access
          code
          createdOn
          modifiedOn
          accessFailedCount
          clauseEditRights
          concurrencyStamp
          groupPolicyEditRights
          lockoutEnabled
          lockoutEnd
          passwordHash
          phoneNumberConfirmed
          planCoverEditRights
          policyEndDateEditRights
          securityStamp
          twoFactorEnabled
          allowPolicyCancellation
          allowPolicyCorrection
          allowPolicyCorrectionAfterClosing
          allowPolicyEndorsement
          allowTransactionModification
          productionClosingRights
          policyIssueDateEditRights
          reinsuranceClosingRights
          amendmentIssueDateEditRights
          allowClaimReopening
          allowTreatyModification
          allowTreatyRedistribution
          allowDistributionModification

          editableChargesLines {
            createdBy
            createdOn
            id
            lineID
            modifiedBy
            modifiedOn
            userID
            line {
              abbreviation
              abbreviationArabic
              code
              createdBy
              createdOn
              id
              modifiedBy
              modifiedOn
              name
              nameArabic
              status
            }
          }
        }
        person {
          code
          fullName
          title
          personTitle {
            title
          }
        }
      }
    }
  }
`;

export const getEntityAuditTrails = gql`
  query getEntityAuditTrails($id: String!) {
    core {
      getEntityAuditTrails(id: $id) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;

export const getUserAssignedLines = gql`
  query getUserAssignedLines(
    $pagination: PaginationInput!
    $selectedUserID: String!
    $OrderBy: OrderByInput!
    $keywordSearch: String
  ) {
    salesforce {
      searchUserAssignedLines(
        pagination: $pagination
        userID: $selectedUserID
        orderBy: $OrderBy
        keyword: $keywordSearch
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          createdBy
          createdOn
          id
          lineID
          modifiedBy
          modifiedOn
          status
          userID
          line {
            abbreviation
            abbreviationArabic
            code
            createdBy
            createdOn
            id
            modifiedBy
            modifiedOn
            name
            nameArabic
            status
          }
          user {
            access
            accessFailedCount
            code
            concurrencyStamp
            createdBy
            createdOn
            email
            emailConfirmed
            firstName
            id
            lastName
            lockoutEnabled
            lockoutEnd
            middleName
            modifiedBy
            modifiedOn
            normalizedEmail
            normalizedUserName
            passwordHash
            personId
            phoneNumber
            phoneNumberConfirmed
            securityStamp
            status
            twoFactorEnabled
            type
            userName
          }
        }
      }
    }
  }
`;

export const getBusinessPartnersPlansList = gql`
  query getBusinessPartnersPlansList(
    $pagination: PaginationInput
    $selectedBusinessPartnerID: [String!]
    $selectedUserID: String!
    $selectedLineID: [String!]
    $selectedPlanID: [String!]
    $OrderBy: OrderByInput
    $keywordSearch: String
  ) {
    salesforce {
      searchUserAssignedBPPlan(
        pagination: $pagination
        businessPartners: $selectedBusinessPartnerID
        userID: $selectedUserID
        lines: $selectedLineID
        plans: $selectedPlanID
        orderBy: $OrderBy
        keyword: $keywordSearch
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          businessPartnerID
          businessPartnerLineID
          businessPartnerPlanID
          createdBy
          createdOn
          id
          lineID
          modifiedBy
          modifiedOn
          planID
          status
          userID
          businessPartner {
            auxiliaryAccount
            code
            createdBy
            createdOn
            fullName
            hasAccessToAllInsured
            id
            isCompany
            isLocal
            isRegistered
            maxCreditLimitAllowed
            maxCreditLimitAllowedCurrency
            modifiedBy
            modifiedOn
            personId
            registerationExpiryDate
            registerationNumber
            relatedCompany
            status
            taxAuxiliaryAccount
            totalCreditLimitReached
            type
          }
          businessPartnerLine {
            businessPartnerID
            commissionAmount
            commissionAmountCurrency
            commissionApplicableOn
            commissionRate
            commissionType
            createdBy
            createdOn
            creditLimit
            creditLimitCurrency
            creditLimitReached
            gracePeriod
            id
            lineID
            modifiedBy
            modifiedOn
            status
          }
          businessPartnerPlan {
            activeFrom
            activeTo
            businessPartnerID
            businessPartnerLineID
            commissionAmount
            commissionAmountCurrency
            commissionApplicableOn
            commissionRate
            commissionType
            createdBy
            createdOn
            id
            lineID
            modifiedBy
            modifiedOn
            planID
            status
          }
          line {
            abbreviation
            abbreviationArabic
            code
            createdBy
            createdOn
            id
            modifiedBy
            modifiedOn
            name
            nameArabic
            status
          }
          plan {
            abbreviation
            acalCategory
            beneficiaryMaxNumber
            chargesPercentage
            code
            commissionAmount
            commissionAmountCurrency
            commissionApplicable
            commissionApplicableOn
            commissionRate
            commissionType
            createdBy
            createdOn
            effectiveFrom
            effectiveTo
            endorsementCost
            id
            insuredMaxNumber
            isEditableClause
            lineID
            maxTPA
            minTPA
            modifiedBy
            modifiedOn
            name
            nameArabic
            planCurrency
            policyCost
            scratching
            status
            sublineID
            tpaFeesAmount
            tpaFeesApplicableOn
            tpaFeesPercentage
            tpaFeesType
          }
          user {
            access
            accessFailedCount
            code
            concurrencyStamp
            createdBy
            createdOn
            email
            emailConfirmed
            firstName
            id
            lastName
            lockoutEnabled
            lockoutEnd
            middleName
            modifiedBy
            modifiedOn
            normalizedEmail
            normalizedUserName
            passwordHash
            personId
            phoneNumber
            phoneNumberConfirmed
            securityStamp
            status
            twoFactorEnabled
            type
            userName
          }
        }
      }
    }
  }
`;

export const getAssignedBPLinePlanList = gql`
  query getAssignedBPLinePlanList($selectedBusinessUserID: String!) {
    salesforce {
      getDistinctUserAssignedBusinessPartners(userID: $selectedBusinessUserID) {
        id
        fullName
        person {
          id
          fullName
        }
      }
      getDistinctUserAssignedLines(userID: $selectedBusinessUserID) {
        id
        name
        code
      }
      getDistinctUserAssignedPlans(userID: $selectedBusinessUserID) {
        id
        name
        code
      }
    }
  }
`;
